var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 9.99984L9.99935 6.6665M9.99935 6.6665L6.66602 9.99984M9.99935 6.6665V14.3332C9.99935 15.4921 9.99935 16.0716 10.4581 16.7203C10.7629 17.1514 11.6405 17.6834 12.1637 17.7543C12.9511 17.861 13.2501 17.705 13.8482 17.3931C16.5132 16.0028 18.3327 13.2138 18.3327 9.99984C18.3327 5.39746 14.6017 1.6665 9.99935 1.6665C5.39697 1.6665 1.66602 5.39746 1.66602 9.99984C1.66602 13.0843 3.34184 15.7774 5.83268 17.2183",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFileIcon.0bf900df2fa8a1a2fddf00755a800220.svg";
export { ForwardRef as ReactComponent };